import { render, staticRenderFns } from "./OrderNew.vue?vue&type=template&id=46adbbe0&scoped=true&"
import script from "./OrderNew.vue?vue&type=script&lang=js&"
export * from "./OrderNew.vue?vue&type=script&lang=js&"
import style0 from "./OrderNew.vue?vue&type=style&index=0&id=46adbbe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46adbbe0",
  null
  
)

export default component.exports